import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 320px;

  border: 1px solid #E3E3E3;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
`;

export default Wrapper(template);